import { useParams } from "react-router-dom";
import SchedulesPage from "@/pages/SchedulesPage";

/** Project-scoped Schedules tab. Renders the same `SchedulesPage` component
 * used at /schedules, but filters by `projectId` and lays it out without the
 * outer container / PageHeader so it slots into the project sub-tabs. */
export default function ProjectSchedulesPage() {
  const { projectId } = useParams();
  return <SchedulesPage projectId={projectId} embedded />;
}
